import { h, render } from "preact";
import register from "preact-custom-element";
import ProductFormContent from "./product-form-content";

function ProductForm({
  productId,
  idPrefix,
  initialVariantId,
  optionsStyle,
  layout,
  isGiftCard,
  physicalGiftCardProductId,
  swatchRequestEnabled,
  stickyAtc,
}) {
  return (
    <ProductFormContent
      productId={productId}
      idPrefix={idPrefix}
      initialVariantId={initialVariantId}
      optionsStyle={optionsStyle}
      layout={layout}
      isGiftCard={isGiftCard !== undefined}
      physicalGiftCardProductId={physicalGiftCardProductId}
      swatchRequestEnabled={swatchRequestEnabled}
      stickyAtc={stickyAtc === "true"}
    />
  );
}

if (!customElements.get("product-form")) {
  register(
    ProductForm,
    "product-form",
    [
      "product-id",
      "id-prefix",
      "initial-variant-id",
      "options-style",
      "layout",
      "physical-gift-card-product-id",
      "swatch-request-enabled",
      "sticky-atc",
    ],
    {
      shadow: false,
    },
  );
}
